import React from 'react';
import { Upload as AntdUpload, UploadProps } from 'antd';
import styled from '@emotion/styled';
import { InboxOutlined } from '@ant-design/icons';

const StyledAntdUpload = styled(AntdUpload)``;
const StyledAtndUploadDragger = styled(AntdUpload.Dragger)``;

const Upload = (props: UploadProps & { dragger?: boolean }) => {
  const { dragger, ...rest } = props;
  if (dragger) {
    return (
      <StyledAtndUploadDragger {...rest}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Drop your files here, or <a>Browse</a>{' '}
        </p>
        <p className="ant-upload-hint">
          Support: JPG, JPEG, PNG, PDF, DOC, XLSL
        </p>
      </StyledAtndUploadDragger>
    );
  }
  return <StyledAntdUpload {...rest}></StyledAntdUpload>;
};

export default Upload;
